import { FormItemStatus } from '../../components/Form';
import { useFormContext, useFormItemContext } from '../../components/Form/context';
import { ComponentSize } from '../../declarations/common.decl';
export var useForm = function useForm(_ref) {
  var _ref2;

  var validationStatus = _ref.validationStatus,
      id = _ref.id,
      size = _ref.size;
  var formContext = useFormContext();
  var formItemContext = useFormItemContext();
  var componentStatus = validationStatus != null ? validationStatus : formItemContext == null ? void 0 : formItemContext.validationStatus;
  var componentId = id != null ? id : formItemContext == null ? void 0 : formItemContext.name;
  var componentSize = (_ref2 = size != null ? size : formContext == null ? void 0 : formContext.size) != null ? _ref2 : ComponentSize.REGULAR;
  var error = componentStatus === FormItemStatus.ERROR;
  return {
    componentStatus: componentStatus,
    componentId: componentId,
    componentSize: componentSize,
    error: error
  };
};